import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lifedi-learning-center-card',
  templateUrl: './learning-center-card.component.html',
  styleUrls: ['./learning-center-card.component.scss']
})
export class LearningCenterCardComponent implements OnInit {
  @Input() cardDetail: any;
  @Output() viewLearningCenter: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  view() {
    this.viewLearningCenter.emit();
  }

}
